const NotAllowed = () =>
    "(⁄ ⁄>⁄ ▽ ⁄<⁄ ⁄)    イヤよ、イヤよ 見つめちゃイヤ～ん　(｡・//ε//・｡)";

export default NotAllowed;
